module.exports = __webpack_public_path__ + "img/chat.ce3dd1ed.svg";